// extracted by mini-css-extract-plugin
module.exports = {"Toast":"Toast_Toast__2ZZ9p","title":"Toast_title__2bJBj","detail":"Toast_detail__2sB4E","ToastHost":"Toast_ToastHost__3PoYc"};